<app-change-course-header></app-change-course-header>
<div class="row px-2 mt-2">
  <h6 class="px-0">
    <strong class=""> Study Unit Pratice Test Id #: </strong> {{ MockExamSequenceNumber }}
  </h6>
</div>


<div class="row px-2">
  <h5 class="px-0">
    <strong> Study Unit: </strong>
  </h5>
</div>

<div class="row">
  <div class="container">
    <!-- Subject Section -->
    <div *ngFor="let studyUnitQuestion of studyUnitQuestions">
      <p>
        <button
        *ngIf="studyUnitQuestion"
        type="button"
        class="toggle-btn-mock-exam"
        style="color: #0c4788;"
        [ngStyle]="{ cursor: studyUnitQuestion.Study_Unit_Current_Number_Of_Question ? 'pointer' : 'default' }"
        (click)="    studyUnitQuestion.Study_Unit_Current_Number_Of_Question > 0
        ? (studyUnitQuestion.isCollapsed = !studyUnitQuestion.isCollapsed)
        : null"
        [attr.aria-expanded]="!studyUnitQuestion.isCollapsed"
      >
        {{ studyUnitQuestion.Study_Unit_Name }}:
        <span
          style="color: black; margin: 0 10px"
          [ngClass]="{
            'text-danger':
              studyUnitQuestion.Study_Unit_Current_Number_Of_Question <
              studyUnitQuestion.Total_Number_Of_Question
          }"
        >
          {{ studyUnitQuestion.Study_Unit_Current_Number_Of_Question }}
        </span>
        / <span class="text-dark">{{ studyUnitQuestion.Total_Number_Of_Question }}</span>
        <i
          class="fa fa-angle-right"

          *ngIf="studyUnitQuestion.isCollapsed && studyUnitQuestion.Study_Unit_Current_Number_Of_Question"
        ></i>
        <i
          class="fa fa-angle-down"
          *ngIf="!studyUnitQuestion.isCollapsed && studyUnitQuestion.Study_Unit_Current_Number_Of_Question"
        ></i>
        <i
          class="fa fa-plus-circle"
          *ngIf="studyUnitQuestion.Study_Unit_Current_Number_Of_Question != studyUnitQuestion.Total_Number_Of_Question"
          (click)="AddEditQuestion(studyUnitQuestion)"
        ></i>
      </button>

      </p>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="studyUnitQuestion.isCollapsed">
        <div class="card">
          <div class="card-body">
            <table class="table table-bordered custom">
              <thead>
                <tr>
                  <th style="width: 2%; text-align: center; vertical-align: middle;white-space:break-spaces">Question Number</th>
                  <th style="width: 25%; text-align: center; vertical-align: middle;">Topic</th>
                  <th style="width: 2%; text-align: center; vertical-align: middle;">Question Id</th>
                  <th style="width: 35%; text-align: center; vertical-align: middle;">Question</th>
                  <th style="width: 45%; text-align: center; vertical-align: middle;">Answer Choices</th>
                  <th style="width: 2%; text-align: center; vertical-align: middle;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let question of studyUnitQuestion.questions; let i = index">
                  <td class="text-center align-middle">{{ i + 1 }}</td>
                  <td class="">{{ question.Path_Name }}</td>
                  <td class="align-middle">{{ question.Question_ID }}</td>
                  <td
                    class=""
                    [innerHTML]="question.Question_Text"
                  ></td>
                  <td class="align-middle">
                    <ul class="list-unstyled">
                      <li *ngFor="let choice of question.Answer_Choices">
                        <div class="d-flex gap-2">

                            <div class="d-flex align-baseline gap-1">
                              <input
                              type="checkbox"
                              class="form-check-input me-2"
                              [disabled]="true"
                              [checked]="choice.Selected_IND === 'Y'"
                            />
                              <strong *ngIf="choice.Right_Answer_Ind === 'Y'">[R]</strong>
                              <span [innerHTML]="choice.Answer_Choice_Text"></span>
                            </div>
                       <!-- <strong *ngIf="choice.Right_Answer_Ind ==='Y'">[R]</strong> <span [innerHTML]="choice.Answer_Choice_Text"></span> -->
                      </div>
                      </li>
                    </ul>
                  </td>
                  <td class="align-middle text-center">
                    <i class="fa fa-trash pointer-cursor" (click)="onDelete(question)"></i>
                    <i class="fa fa-pencil pointer-cursor ms-2" (click)="onEdit(studyUnitQuestion,question)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
